import { render, staticRenderFns } from "./ReimaginePortalIcon.vue?vue&type=template&id=28bd4407&scoped=true&"
import script from "./ReimaginePortalIcon.vue?vue&type=script&lang=js&"
export * from "./ReimaginePortalIcon.vue?vue&type=script&lang=js&"
import style0 from "./ReimaginePortalIcon.vue?vue&type=style&index=0&id=28bd4407&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd4407",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28bd4407')) {
      api.createRecord('28bd4407', component.options)
    } else {
      api.reload('28bd4407', component.options)
    }
    module.hot.accept("./ReimaginePortalIcon.vue?vue&type=template&id=28bd4407&scoped=true&", function () {
      api.rerender('28bd4407', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/images/icons/ReimaginePortalIcon.vue"
export default component.exports